import { ChevronDownFilled } from "@fluentui/react-icons";
import { ReactComponent as Logo } from "assets/RewardsLogo.svg";
import ReactPopover from "components/Common/Popover";
import HeaderPopoverContent from "components/Header/HeaderPopoverContent";
import { useLocalStorage } from "hooks/useLocalStorage";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const TopBar: React.FC<{ authContext: AuthContextType }> = ({
  authContext,
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const onClose = () => setOpen(false);

  return (
    <div className="bg-white fixed w-full z-50">
      <div className={`flex flex-row p-4 mx-auto md:w-[65vw]`}>
        <div className="flex-1 h-100 cursor-pointer">
          <Logo width={140} height={40} onClick={() => navigate("/")} />
        </div>
        <div>
          <ReactPopover
            contentClass={"md:left-[-180px] md:w-[80px]"}
            onClose={onClose}
            open={open}
            content={
              <HeaderPopoverContent
                authContext={authContext}
                setOpen={setOpen}
                onClose={onClose}
              />
            }
          >
            <div
              className="flex gap-2 md:pr-8 items-end md:items-center"
              onClick={() => setOpen(true)}
            >
              <span>{authContext?.user?.name || ""}</span>
              <ChevronDownFilled fontSize={32} className="m-auto" />
            </div>
          </ReactPopover>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
